/**
 * @flow weak
 */

export const SELECT_NAV_ITEM = 'SELECT_NAV_ITEM';

export const selectNavItem = (item, index) => {
  return {
    type: SELECT_NAV_ITEM,
    item,
    index
  };
};



// WEBPACK FOOTER //
// ./src/modules/nav/actions.js